module.exports = __webpack_public_path__ + "static/media/android.36571833.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/android.svg
// module id = 2860
// module chunks = 0